module.exports = "<p>\n  bu-reports-scorecards works!\n</p>\n"